import {SET_MY_USER, USER_ME_REQUEST, USER_RESET} from "../actions/user";
import Vue from "vue";
import ApiService from "@/utils/api.service";
import Crud from "../crud";
var crud = new Crud("users");

const state = {
  profile: {},
  ...crud.state,
};

const getters = {
  getProfile: (state) => state.profile,
  isProfileLoaded: (state) => !!state.profile.name,
};

const actions = {
  [USER_ME_REQUEST]: ({ commit }) => {
    return ApiService.get(`users/?myself=true`)
      .then((resp) => {
        commit(SET_MY_USER, resp.data[0]);
      })
      .catch(() => {
        // if resp is unauthorized, logout, to
        commit(USER_RESET);
      });
  },
  ...crud.actions,
};

const mutations = {
  [SET_MY_USER]: (state, resp) => {
    Vue.set(state, "profile", resp);
  },
  [USER_RESET]: (state) => {
    state.profile = {};
  },
  ...crud.mutations,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
